// library imports
import { useState, useEffect, useContext } from "react";
import { Empty, Skeleton, theme, Flex, Modal } from "antd";
// component imports
import Heatmap from "../common/Heatmap";
// hook imports
import useFetch from "../../hooks/useFetch";
// context imports
import { IndexContext } from "../../context/IndexContext";

export default function HeatmapContent({
  parentContainerHeight,
  dateSelected,
  dateType,
}) {
  const [fetchWrapper] = useFetch();
  const { siteSelected, notificationApi } = useContext(IndexContext);

  // theme token
  const { token } = theme.useToken();

  // loading state
  const [loading, setLoading] = useState(false);

  // modal state
  const [modalOpen, setModalOpen] = useState(false);

  // data
  const [heatmapData, setHeatmapData] = useState([]);

  // chart date
  const [chartDate, setChartDate] = useState("");

  /** API to get heatmap data */
  function getPowerHeatmapData() {
    setLoading(true);

    fetchWrapper({
      endpoint_url: "dashboard/getHeatmapData",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
        date_selected: dateSelected
          .startOf("month")
          .format("YYYY-MM-DD HH:mm:ss"),
        date_type: dateType,
      },

      onSuccess: (response) => {
        setHeatmapData(response.data.chart_data);
        setChartDate(response.data.chart_date);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: "Failed to get heatmap data.",
          description: response.statusText,
        });
      },

      onFinish: () => {
        setLoading(false);
      },
    });
  }

  useEffect(() => {
    if (siteSelected && dateSelected && dateType) {
      getPowerHeatmapData();
    }
  }, [siteSelected, dateSelected, dateType]);

  return (
    <div className="h-100 w-100">
      <div
        style={{
          fontWeight: "bold",
          fontSize: "1rem",
          paddingLeft: "12px",
        }}
      >
        Power Heatmap {loading ? "" : `(${chartDate})`}
      </div>
      {loading === false ? (
        heatmapData.length !== 0 ? (
          <Heatmap
            data={heatmapData}
            x="Date"
            y="Device"
            color="Performance Ratio"
            themeToken={token}
            height={parentContainerHeight - 24 - 26} //parent container height - card body padding - title height
            yAxisTitle={"Device"}
            xAxisTitle={"Date"}
            onFullscreen={() => setModalOpen(true)}
          />
        ) : (
          <Flex
            vertical
            justify="center"
            align="center"
            style={{
              height: `calc(${parentContainerHeight}px - 24px - 26px)`,
            }}
          >
            <Empty />
          </Flex>
        )
      ) : (
        <Skeleton
          active={true}
          style={{ padding: "1rem", maxWidth: "70%", margin: "auto" }}
          paragraph={{ rows: 5 }}
        />
      )}
      <Modal
        title={`Power Heatmap (${chartDate})`}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        width="95vw"
        style={{ top: 20 }}
        styles={{ body: { padding: "12px 24px" } }}
      >
        <Heatmap
          data={heatmapData}
          x="Date"
          y="Device"
          color="Performance Ratio"
          themeToken={token}
          height={Math.round(window.innerHeight * 0.8)}
          yAxisTitle={"Device"}
          xAxisTitle={"Date"}
        />
      </Modal>
    </div>
  );
}
